import { BiArrowToRight } from "react-icons/bi";
import { Link } from "react-router-dom";

const Apply = () => {
    return (
        <div className="bg-[#0a1a42]  px-12 max-[670px]:px-2 py-4">
            {/* <h2 className="text-gray-300 text-sm">2024 JANUARY ADMISSIONS</h2> */}
            <h1 className="text-gray-100 pt-4 text-2xl font-serif ">Apply for Admission</h1>
            <h3 className="pt-4 text-gray-200 font-roboto">
                Ready to take the next step towards a future filled with limitless
                opportunities? Apply for admission today!
            </h3>
            {/* <h2 className="pt-4 text-gray-300">Applications ends January 4, 2023</h2> */}

            <div className="pt-4 space-x-4">
                <Link to={'/admission'}>
                    <button className="bg-[#f7951e] red-600 font-serif px-6 py-3 text-white">Apply Now</button>
                </Link>
                <button>

                    <span className="flex text-gray-300 place-items-center space-x-2">
                        <h2> Learn more</h2>
                        <BiArrowToRight className="text-xl" />
                    </span>
                </button>
            </div>
        </div>
    );
}

export default Apply;